import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UnifiedLoginService } from './unified-login/unified-login.service';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  constructor(private unifiedLoginService: UnifiedLoginService) {}

  private handleAuthError(err: HttpErrorResponse): Observable<HttpEvent<any>> {
    if (err.status === 401 || err.status === 403) {
      this.unifiedLoginService.redirectToLogin();
    }
    return throwError(() => err);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userInfo = this.unifiedLoginService.getUserInfo();
    switch (userInfo.type) {
      case 'USER_LOGIN_SUCCESS_RESPONSE': {
        const { legacyJWT } = userInfo;
        if (legacyJWT) {
          const authenticatedRequest = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${legacyJWT}`),
          });
          return next.handle(authenticatedRequest).pipe(catchError((x) => this.handleAuthError(x)));
        }
      }
    }

    return next.handle(req).pipe(catchError((x) => this.handleAuthError(x)));
  }
}
